import { Component, Input } from "@angular/core";
import { LayoutService } from "../../services/layout.service";

@Component({
    selector: "app-svg-icon",
    template: `<img [src]="icon" alt="Icon" class="svg-icon" />`,
    styles: [`
    .svg-icon {
      width: 24px; /* Adjust size as needed */
      height: 24px; /* Adjust size as needed */
    }
  `],
    standalone: false
})
export class SvgIconComponent { 
  @Input("icon") public icon;
  public iconValue;
  constructor(public layOut: LayoutService) {}

  getSvgType() {
    return document.getElementsByClassName("sidebar-wrapper")[0].getAttribute("icon") == "stroke-svg";
  }
}
